{
    "warning": "PERINGATAN!",
    "message": "Jangan memasukkan atau menempelkan kode yang tidak Anda pahami.\nMenggunakan konsol ini dapat memberikan akses kepada penyerang untuk menyamar sebagai Anda dan mencuri informasi menggunakan serangan yang disebut Self-XSS."
}
